import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { publishersDelete } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useDeletePublisher = (
  options: UseMutationOptions<void, unknown, { id: number }, unknown> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }) => extractData(publishersDelete({ path: { id } })),
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({
        queryKey: ['publisher', variables.id],
      });
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
